/**
 * MediaProtection – global-lytter som blokker høyre-klikk-nedlasting av
 * bilder og videoer på hele siden.
 *
 * Merk: dette er UX-barriere, ikke sikkerhet. Bestemte brukere kan fortsatt
 * hente ut filer via DevTools. Reell tilgangskontroll sitter i backend
 * (/api/images/{id}/raw og /api/videos/{id}/raw).
 */
import { useEffect } from "react";

export default function MediaProtection() {
  useEffect(() => {
    const onContextMenu = (e) => {
      const t = e.target;
      if (!t) return;
      const tag = t.tagName;
      // Blokker høyre-klikk på bilder, videoer, og <picture> og deres source
      if (tag === "IMG" || tag === "VIDEO" || tag === "SOURCE" || tag === "PICTURE") {
        e.preventDefault();
        return false;
      }
      // Blokker også høyre-klikk på elementer som har bakgrunnsbilde satt
      const bg = window.getComputedStyle(t).backgroundImage;
      if (bg && bg !== "none" && bg.includes("url(")) {
        e.preventDefault();
        return false;
      }
    };
    const onDragStart = (e) => {
      const t = e.target;
      if (!t) return;
      if (t.tagName === "IMG" || t.tagName === "VIDEO") {
        e.preventDefault();
        return false;
      }
    };
    document.addEventListener("contextmenu", onContextMenu, { capture: true });
    document.addEventListener("dragstart", onDragStart, { capture: true });
    return () => {
      document.removeEventListener("contextmenu", onContextMenu, { capture: true });
      document.removeEventListener("dragstart", onDragStart, { capture: true });
    };
  }, []);
  return null;
}
